import { useMemo } from 'react';

import { useGetCountriesQuery } from '@app/api/Dictionaries';
import { adaptDataToSelect } from '@app/utils';

export const useCountriesSelect = () => {
  const { data } = useGetCountriesQuery({});

  const countries = useMemo(() => {
    return adaptDataToSelect(data || []);
  }, [data]);

  return {
    countries,
  };
};
